import type { TCredenciaisLogin } from '@/features/user/interfaces'
import type { TUsuarioLogado } from '@/shared/interfaces/user'
import { HttpService } from '@/shared/lib'

export class LoginService extends HttpService {
  execute = async (credenciais: TCredenciaisLogin) => {
    const response = await this.http.post<TUsuarioLogado, TCredenciaisLogin>(`/api/v2/Login`, credenciais)
    return response
  }
}
